const target = window

export class Broker {
  constructor (ns, sender = 'app', id) {
    this.ns = ns
    this.id = id && String(id) || Math.random().toString(36).substring(2)
    this.sender = sender
  }

  emit (action, payload = {}) {
    const message = {
      ns: this.ns,
      id: this.id,
      sender: this.sender,
      action,
      payload
    }

    target.postMessage(message, '*')
  }

  on (action, cb) {
    const handleMessage = (event) => {
      const data = event.data
      if (data.ns === this.ns && data.id === this.id && data.action === action && data.sender !== this.sender) {
        cb(data.payload, action)
      }
    }

    target.addEventListener('message', handleMessage)

    return () => target.removeEventListener('message', handleMessage)
  }

  once (action, cb) {
    const cancel = this.on(action, () => {
      cb()
      cancel()
    })
  }
}
